import moment from "moment";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import AppStateHandler from "src/StateHandlers/AppStateHandler";
import ChatStateHandler, { useChatState } from "src/StateHandlers/ChatStateHandler";

function Messages({ chatData }: any) {
  const { t, i18n } = useTranslation();
  const history = useHistory()
  const [message, setMessage] = useState<string>('');
  const [scroll, setScroll] = useState<any>();
  const dates: any = [];
  const ids: any = [];
  const { user } = AppStateHandler.getState();
  const { senderId, senderName, senderImage, receiverId, receiverName, receiverImage } = chatData;
  const subId = user.username === senderId ? receiverId : senderId;
  const chattingWith = user.username === senderId ? receiverName : senderName;
  const chattingWithImg = user.username === senderId ? receiverImage : senderImage;
  const scrollToBottom = () => {
    scroll && scroll.scrollIntoView({ behavior: "smooth" });
  }
  const [
    {
      activeChatData,
      activeChatId,
      online,
      isBlocked,
      hasBlocked,
      loading,
      chatList,
    },
  ] = useChatState();
  useEffect(() => {
    scrollToBottom()
  }, [activeChatData?.length])

  useEffect(() => {
    if (online) {
      ChatStateHandler.setState({ userId: subId });
      ChatStateHandler.getChatHistory(subId);
    }
    return () => {
      ChatStateHandler.setState({
        activeChatData: [],
        activeChatId: '',
        userId: '',
        isBlocked: false,
        hasBlocked: false,
      });
    };
  }, [subId, online]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      ChatStateHandler.getChatHistory(subId);
    }, 3000)
    return () => clearInterval(intervalId);
  }, [])

  const handleSendMessage = () => {
    if (message.trim() !== '') {
      ChatStateHandler.sendMessage({
        receiverId: subId,
        message: message,
        chatId: activeChatId,
      });
      setMessage('');
    }
  }

  const handleBlockUnblock = () => {
    if (hasBlocked) {
      ChatStateHandler.unBlockUser();
    } else {
      ChatStateHandler.blockUser();
    }

  }
  return (
    <div id="frame">
      <div className="content">
        <div className="contact-profile d-flex align-items-center justify-content-between">
          <div className={`d-flex align-items-center ${i18n.dir()=== "rtl" && "text-right"}`}>
            <i className= {`fa fz20 cursor-pointer ${i18n.dir()==='rtl'?'ml-3 fa-angle-right':'mr-3 fa-angle-left '}`} onClick={() => history.goBack()} aria-hidden="true"></i>
            <img src={chattingWithImg !== "" ? chattingWithImg : "/assets/images/profile-camera.png"} width="40" height="40" alt="" className={`mt-2 ${i18n.dir()=== "rtl" && "mr-0 ml-3"}`} />
            <p style={{ lineHeight: 'initial' }} className="mt-3">{chattingWith} <br /><span className="base_color fz10">{chatList?.find((_) => _?.online === 1) ? t('Online') : t('Offline')}</span></p>
          </div>
          <div className="social-media">
            <span className="fz14 text-secondary cursor-pointer" onClick={handleBlockUnblock}>{hasBlocked ? t("Unblock") : t("Block")}</span>
          </div>
        </div>
        <div className="custom_messages">
          <ul className="p-0">
            {
              activeChatData?.sort((a, b) => {
                if (a.createdAt < b.createdAt) {
                  return -1;
                }
                if (a.createdAt > b.createdAt) {
                  return 1;
                }
                return 0;
              })?.map((_msg: any, i: number) => {
                const { user: chatuser } = _msg;
                const today = moment(new Date()).format('MMM d, Y');
                const date = _msg.createdAt ? moment(new Date(_msg.createdAt)).format('MMM d, Y') : "-";
                if (!dates.includes(date)) {
                  ids.push(_msg._id);
                  dates.push(date);
                }
                return user.username === chatuser._id ?
                  <>
                    {ids.includes(_msg._id) ? <h5 className="fz12 text-secondary my-4 text-center">{today === date ? 'Today' : date}</h5> : <></>}
                    <li className="replies" key={_msg._id}>
                      <img className="rounded-circle" width="30" height="30" src={chatuser.avatar !== "" ? chatuser.avatar : "/assets/images/profile-camera.png"} alt="" />
                      <p style={{fontFamily: i18n.dir()==='rtl'? "Almaraisemibold" :""}}>{_msg.text}</p>
                      <span className="fz10 float-right">{_msg.createdAt ? moment(new Date(_msg.createdAt)).format('hh:mm A') : ""}</span>
                    </li>
                  </>
                  : <>
                    {ids.includes(_msg._id) ? <h5 className="fz12 text-secondary my-4 text-center">{today === date ? 'Today' : date}</h5> : <></>}
                    <li className="sent" key={_msg._id}>
                      <img className="rounded-circle" width="30" height="30" src={chatuser.avatar !== "" ? chatuser.avatar : "/assets/images/profile-camera.png"} alt="" />
                      <p style={{fontFamily: i18n.dir()==='rtl'? "Almaraisemibold" :""}}>{_msg.text}</p>
                      <span className="fz10">{_msg.createdAt ? moment(new Date(_msg.createdAt)).format('hh:mm A') : ""}</span>
                    </li>
                  </>
              })
            }
          </ul>
          <div style={{ float: "left", clear: "both" }} ref={(e) => setScroll(e)}></div>
        </div>
        <div className="message-input">
          <div className="wrap">
            <input type="text" value={message} disabled={isBlocked || hasBlocked} placeholder={hasBlocked
              ? 'You have blocked this user'
              : !isBlocked
                ? t('Write a message')
                : 'You have been blocked'} onChange={e => setMessage(e.target.value)} style={{float : i18n.dir() === 'rtl' ? "right":"left"}}/>
            <i
              className={`fa fa-paper-plane position-absolute base_color cursor-pointer ${i18n.dir() === 'rtl' && 'fa-flip-horizontal'}`}
              style={{ right: `${i18n.dir()==='rtl'?'':'50px'}`, top: "10px", fontSize: "24px", left:`${i18n.dir()==='rtl'?'50px':''}` }}
              aria-hidden="true"
              onClick={handleSendMessage}
            ></i>
          </div>
        </div>
      </div>
    </div>
  )
}
export default Messages;
